let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fhR3Z"), load("3wN5D")]).then(() => parcelRequire('c19c2'));